<template>
  <table border="1" class="custom-invoice-table">
    <thead>
      <tr>
        <th v-for="(header, index) in headers" :key="'header-' + index">
          {{ header }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, rowIndex) in bodyRows" :key="'row-' + rowIndex">
        <td v-for="(cell, colIndex) in row" :key="'cell-' + rowIndex + '-' + colIndex">
          <a v-if="isShow(cell)" href="#" @click.prevent="copy(cell, rowIndex, colIndex)">
            <FontAwesomeIcon icon="fas fa-clipboard custom-clipboard" />
          </a>
          {{ cleanup(cell) }}
          <FontAwesomeIcon v-if="isCopied(rowIndex, colIndex)" icon="fas fa-check-circle" :style="{ color: 'green' }" />
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { invoiceStore } from '@/stores/invoice'
import globals from '@/plugins/globals'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default {
  name: 'InvoiceTable',
  components: {
    FontAwesomeIcon
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    idx: {
      type: Number,
      required: true
    },
    table: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState(invoiceStore, ['loading', 'copiedCells', 'selectedCells']),
    isLoading() {
      return this.loading?.analysis || this.loading?.invoice || false
    },
    tableRows() {
      const groupedRows = {}
      if (this.table) {
        this.table.forEach((item) => {
          if (!groupedRows[item.RowIndex]) {
            groupedRows[item.RowIndex] = []
          }
          groupedRows[item.RowIndex][item.ColumnIndex] = item.Content || '' // Ensure order
        })
      }
      return Object.values(groupedRows)
    },
    headers() {
      return this.tableRows[0] || []
    },
    bodyRows() {
      return this.tableRows.slice(1)
    }
  },
  methods: {
    ...mapActions(invoiceStore, ['resetCells', 'cellAction']),
    cleanup(cell) {
      if (!cell) return '' // Ensure cell is a valid string
      const unwantedStrings = [':unselected:', ':selected:', ':placeholder:']
      return unwantedStrings.reduce((acc, str) => acc.replaceAll(str, ''), cell)
    },
    copy(cell, rowIndex, colIndex) {
      let selectedText = window.getSelection().toString().trim()
      let textToCopy = selectedText || cell
      console.log('textToCopy:', textToCopy)
      if (textToCopy === '') return
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          window.getSelection().removeAllRanges()
          // Mark the cell as copied
          const key = `${rowIndex}-${colIndex}`
          this.cellAction({
            name: 'copy',
            page: this.page,
            idx: this.idx,
            value: key
          })
          // if it's a number, add it to our total so far
          if (globals.isNumeric(textToCopy.replace(/[$,]/g, ''))) {
            this.cellAction({
              name: 'select',
              page: this.page,
              idx: this.idx,
              value: textToCopy,
              key: key
            })
          }
        })
        .catch((err) => console.error('Clipboard copy failed:', err))
    },
    isShow(cell) {
      return cell && cell.length > 0
    },
    isCopied(rowIndex, colIndex) {
      let _is = false
      let found = this.copiedCells.find((cell) => cell.page === this.page && cell.idx === this.idx && cell.data === `${rowIndex}-${colIndex}`)

      if (found !== null && found !== undefined) {
        _is = true
      }
      return _is
    }
  }
}
</script>

<style scoped lang="scss">
.custom-clipboard {
  color: black;
  transition: color 0.3s ease-in-out;
}

.custom-clipboard-copied {
  color: green !important;
}
.custom-invoice-table {
  width: 100%;
}
</style>
